import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import HomeWarrantyCenterWrapper from "@components/layouts/homewarrantycenterWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

export default function HomeWarrantyCenter(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <HomeWarrantyCenterWrapper>
            <TermsAndConditions
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </HomeWarrantyCenterWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
